(function() {
  'use strict';

  angular
    .module('aims', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'aims-frontend-components',
      'jm.i18next',
      'ngMask',
      'toaster',
      'angular.filter'
    ])

    /*@ngInject*/
    .config(function($httpProvider, authInterceptorProvider, aimsPlatformProvider) {
      $httpProvider.interceptors.push(authInterceptorProvider.$get);

      aimsPlatformProvider.setAimsUrl(window.config.aims.api);
      aimsPlatformProvider.setAppName('aims');
      aimsPlatformProvider.setKeycloakAuth(window.config.auth.keycloak);

      aimsPlatformProvider.options = {
        useOwnToaster: true,  // Use toaster container from host app; false - use AFC toaster container
        notificationPollTime: 30000,
        loginState: window.config.auth.loginState,
        authenticatedState: window.config.auth.authenticatedState,
        unAuthenticatedState: window.config.auth.unAuthenticatedState,
        appColor: '#469FAE', // Color specified in the Sketch design from Karla Galvan
        appDisplayName: 'AIMS Platform', // Set these two options in the run section
        appDisplayDescription: 'A secure, cloud based environment that accelerates the implementation of health messaging by providing shared services to aid in the transport, validation, translation, transformation and routing of electronic data.',
        appDisplayDescription2: 'This system is restricted solely to authorized users and may be monitored for administrative and security reasons. The user expressly consents to such monitoring. Any use of this system must be in compliance with APHL policies and applicable laws. Unauthorized users or any unauthorized use may subject the user to criminal and civil penalties under state, federal, or other applicable domestic and foreign laws.'
      };

      var aims = window.config.aims.url;

      aimsPlatformProvider.setLinks({
        aims: aims,
        notifications: aims + '/#/index/notifications',
        notificationsConfig: aims + '/#/index/notificationsconfig',
        support: aims + '/#/index/support',
        profile: aims + '/#/index/profile'
      });

      aimsPlatformProvider.setRoutes({
        notifications: 'index.notifications',
        notificationsConfig: 'index.notificationsconfig',
        support: 'index.support',
        supportDetail: 'index.supportdetail',
        landing: 'landing',
        resources: 'resources',
        profile: 'index.profile'
      });
    })

    .controller('AppController', function($log, Auth, Intervals) {
      var vm = this;

      vm.adminAccess = Auth.user.clientsWithRole('AccessAdmin').length > 0;
      vm.notifierAccess = Auth.user.hasClientRole('aims', 'NotificationSend')

      if (Auth.user.authenticated()) {
        if (typeof vm.tokenInterval === 'undefined') {
          vm.tokenInterval = Intervals.setInterval(function() {
            try {
              if (Auth.get().isTokenExpired()) {
                Auth.user.logout();
              }
            } catch(e) {
              Auth.user.logout();
            }
          }, 2 * 1000); //Check every two seconds if the token is expired
        }
      } else {
        Intervals.clearAll();
      }

    })

    ;

})();

angular
  .module("aims")

  .factory("Resources", function () {
    var docs = [
      {
        title: "AIMS One Page Summary",
        description:
          "AIMS is a secure, cloud based environment that accelerates the implementation of health messaging by providing shared services to aid in the transport, validation, translation and routing of electronic data.",
        source: "AIMS_OnePager",
        order: 2,
      },
      {
        title: "AIMS Impact",
        description: "",
        source: "AIMS-Impact",
        order: 3,
      },
      {
        title: "AIMS Technical Offering",
        description:
          "A summary of technical services and tools offered and used by AIMS Platform.",
        source: "AIMSTechnicalSummary2020",
        order: 4,
      },
      {
        title: "AIMS FAQ",
        description: "Frequently Asked Questions.",
        source: "AIMSFAQ",
        order: 1,
      },
      {
        title: "AIMS Security Practices",
        description: "Frequently Asked Questions about Security.",
        source: "AIMSSecurityOnePager",
        order: 5,
      },
      {
        title: "Message Tracker User Guide",
        description:
          "This guide is designed to assist Message Tracker users with the processes inside the application, including message restoration, search, and support. Use this guide to learn how to submit feature requests and report bugs.",
        source: "20170620MessageTrackerGuidewithScreenshotsv1",
        order: 7,
      },
    ];

    function getResources() {
      return docs;
    }

    return {
      getResources: getResources,
    };
  });

angular.module('aims')

.factory('NotifierService', function($http, ConfigService, Auth) {

  function resToData (res) {
    return res.data
  }

  function http (path, method, data) {
    return $http({
      method: method,
      url: ConfigService.aims.api + path,
      data: data
    }).then(resToData)
  }

  function httpGet (path) {
    return http(path, 'get')
  }

  function httpPost (path, data) {
    return http(path, 'post', data)
  }

  function getApps () {
    var clients = Auth.user.clientsWithRole('NotificationSend')
    return Promise.all(clients.map(function (client) {
      return httpGet('/apps/' + client).catch(function () {
        return {
          name: client,
          displayName: client + ' (Unrecognized App)'
        }
      })
    }))
  }

  function getNotificationTypes () {
    return httpGet('/notificationTypes')
  }

  function sendBulk (data) {
    return httpPost('/notifications/bulk', data)
  }

  return {
    sendBulk: sendBulk,
    getNotificationTypes: getNotificationTypes,
    getApps: getApps
  };

});

angular.module('aims')

.factory('Intervals', function($interval) {

  var intIDs = [];

  function setInterval(fn, interval) {
    var intervalId = $interval(fn, interval);
    intIDs.push(intervalId);
    return intervalId;
  }

  function cancelInterval(intervalId) {
    $interval.cancel(intervalId);
  }

  function clearAll() {
    intIDs.forEach(function(element, index, array) {
      $interval.cancel(array[index]);
    });
  }

  return {
    setInterval: setInterval,
    cancelInterval: cancelInterval,
    clearAll: clearAll
  };

});

'use strict';

angular.module('aims')
.controller('ResourcesController', function(Resources) {

  var vm = this;

  vm.resources = Resources.getResources();

})

;

'use strict';

angular.module('aims')
.controller('LandingController', function (ConfigService, Resources) {

  var vm = this;

  vm.pCollapsed = true;

  vm.collapseToggle = function(){
    vm.pCollapsed = !vm.pCollapsed;
  }

  vm.resources = Resources.getResources();

  vm.init = function() {
    vm.validatorOnline = ConfigService.aims.validator;
  }
  vm.init();

})

.controller('ContactFormController', function ContactFormController(ContactFormService){

  var vm = this;

  vm.submitted = false;
  vm.formData = {};
  vm.formData.name = "";
  vm.formData.email = "";
  vm.formData.message = "";

  vm.processForm = function() {

    ContactFormService.submitContact({
      name: vm.formData.name,
      email: vm.formData.email,
      message: vm.formData.message
    }).then(function() {
      vm.submitted = true;
    });
  };

})

  ;

'use strict';

angular.module('aims')

.service('ContactFormService', function($q, $http) {

  return {
    submitContact: function(data) {
      var deferred = $q.defer();

      $http({
        method: 'post',
        url: "https://ed8rncrnok.execute-api.us-east-1.amazonaws.com/prod/aimsplatform-contact",
        data: data,
        skip: true
      }).then(function(response) {
        deferred.resolve({
          lists: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      }).catch(function(exception) {
        deferred.reject({
          exception: exception
        });
      });

      return deferred.promise;
    }

    
  };


});

"use strict";

angular
  .module("aims")
  .controller("DashboardController", function(
    Auth,
    $state,
    aimsApps,
    aimsNotifications,
    aimsSupport,
    $filter,
    $scope,
    aimsProfile,
    ConfigService
  ) {
    var vm = this;

    vm.loadProfile = function() {
      aimsProfile.getProfileByEmail(vm.kcUserInfo.email).then(function(data) {
        vm.userProfile = data.data;
      });
    };

    vm.loadApps = function() {
      vm.appsLoading = true;
      vm.appsError = false;

      aimsApps
        .getAccessibleApps()
        .then(
          function(data) {
            vm.apps = $filter("omit")(data.data, 'name === "aims"');
            vm.apps.push({
              name: "validator",
              logo: "assets/images/landing/apps/VALIDATORLOGO.png",
              displayName: "AIMS eICR Online Validator",
              url: ConfigService.aims.validator
            });
          },
          function() {
            vm.appsError = true;
          }
        )
        .finally(function() {
          vm.appsLoading = false;
        });
    };

    vm.loadUnreadNotifications = function() {
      vm.notificationsLoading = true;
      vm.notificationsError = false;
      aimsNotifications
        .getNotifications({ read: false })
        .then(
          function(data) {
            vm.notifications = $filter("limitTo")(
              $filter("orderBy")(data.data, "-created_at"),
              "10"
            );
            vm.allUnread = data.data.length;
          },
          function() {
            vm.notificationsError = true;
          }
        )
        .finally(function() {
          vm.notificationsLoading = false;
        });
    };

    vm.loadIssues = function() {
      vm.issuesLoading = true;
      vm.issuesError = false;
      aimsSupport
        .getIssues()
        .then(
          function(data) {
            if (data.status === 200) {
              vm.issues = data.data;
            } else {
              vm.issuesError = true;
            }
          },
          function() {
            vm.issuesError = true;
          }
        )
        .finally(function() {
          vm.issuesLoading = false;
        });
    };

    $scope.$on("new-notification", function() {
      vm.loadUnreadNotifications();
    });

    vm.init = function() {
      vm.kcUserInfo = Auth.user.get();
      vm.loadProfile();
      vm.loadApps();
      vm.loadUnreadNotifications();
      vm.loadIssues();
    };
    vm.init();
  });

'use strict';

var config = {

  env: {
    name: 'sandbox',
    displayName: 'Sandbox'
  },

  aims: {
    url: 'https://www.sandbox.aimsplatform.com', // Need it for profile link
    api: 'https://api.sandbox.aimsplatform.com',
    appUrl: 'https://www.sandbox.aimspaltform.com/',
    application: 'aims',
    contactUrl: 'https://fkoq94vtsb.execute-api.us-east-1.amazonaws.com/prod/steve2-contact',
    validator: 'https://validator.aimsplatform.org/'
  },

  auth: {
    keycloak: 'https://auth.sandbox.aimsplatform.com/auth',
    loginState: 'login',
    authenticatedState: 'index.dashboard',
    unAuthenticatedState: 'landing'
  }
};

angular.module('aims')

.factory('ConfigService', function() {

  return {
    environment: config.env,
    keycloak: config.keycloak,
    api: config.api,
    aims: config.aims
  };

});

'use strict';

angular.module('aims')

.component('loadSpinner', {
  bindings: {
    size: '@'
  },
  transclude: true,
  templateUrl: 'app/components/common/spinner_double_bounce.tpl.html'
})

.component('emptyList', {
  bindings: {
    icon: '@'
  },
  transclude: true,
  templateUrl: 'app/components/common/emptyList.tpl.html'
})

.component('addressFormat', {
  bindings: {
    address: '='
  },
  templateUrl: 'app/components/common/addressFormat.tpl.html'
})

;

'use strict';

angular.module('aims')
.controller('NotifierController', function (NotifierService, $log, toaster, $i18next) {
  var vm = this
  var steveRealms = ['ne-steve2','wy-steve2','va-steve2','dc-steve2','mt-steve2','ny-steve2','nc-steve2','ky-steve2','ga-steve2','ri-steve2','tn-steve2','mi-steve2','ct-steve2','oh-steve2','mn-steve2','ak-steve2','vi-steve2','nh-steve2','sd-steve2','ia-steve2','co-steve2','fl-steve2','nj-steve2','ok-steve2','nd-steve2','md-steve2','mo-steve2','tx-steve2','vt-steve2','la-steve2','ms-steve2','ut-steve2','wa-steve2','de-steve2','nv-steve2','sc-steve2','wv-steve2','ma-steve2','ar-steve2','or-steve2','az-steve2','in-steve2','pa-steve2','pr-steve2','al-steve2','wi-steve2','ca-steve2','ks-steve2','hi-steve2','nyc-steve2','nm-steve2','me-steve2','il-steve2','id-steve2']
  var toAllSteve = [{ app: 'grafana-cdc' }].concat(steveRealms.map(function (realm) {
    return {
      app: 'steve2',
      realm: realm
    }
  }))

  vm.formData = {}
  vm.apps = []
  vm.sending = false
  vm.errorMessages = []

  function loading () {
    vm.loading = true
  }

  function doneLoading () {
    vm.loading = false
  }

  function init () {
    loading()
    return Promise.all([NotifierService.getApps(), NotifierService.getNotificationTypes()])
    .then(function (res) {
      vm.apps = res[0]
      vm.types = res[1]
    })
    .then(doneLoading)
  }

  function buildTo () {
    var selectedApp = vm.formData.app && vm.formData.app.name
    if (selectedApp === 'steve2') {
      return toAllSteve
    }
    return [{ app: selectedApp }]
  }

  function success(notifications) {
    var sentCount =  0
    var failedCount = 0
    vm.errorMessages = []
    notifications.forEach(function (notification) {
      if (notification.error) {
        vm.errorMessages.push('Failed to send notification to user [' + notification.user + '] due to error [' + notification.error.message + ']')
        failedCount++
      } else {
        sentCount++
      }
    })
    if (!sentCount) {
      return failure()
    }
    if (failedCount) {
      vm.warningMessage = ''
      toaster.pop('warning', $i18next.t('notifier.warningTitle'), $i18next.t('notifier.warningMessage', { sentCount: sentCount, failedCount: failedCount }));
    } else {
      toaster.pop('success', $i18next.t('notifier.successTitle'), $i18next.t('notifier.successMessagePre') + sentCount + $i18next.t('notifier.successMessagePost'));
    }
  }

  function failure() {
    toaster.pop('error', $i18next.t('notifier.failureTitle'), $i18next.t('notifier.failureMessage'))
  }

  vm.sendBulk = function () {
    vm.sending = true
    var request = {
      to: buildTo(),
      app: vm.formData.app && vm.formData.app.name,
      type: vm.formData.type && vm.formData.type.name,
      title: vm.formData.title,
      content: vm.formData.content
    }
    return NotifierService.sendBulk(request)
    .then(success, failure)
    .then(function () {
      vm.sending = false
    })
  }

  init()
})

'use strict';

angular.module('aims')
.factory('Access', function($q, $http, ConfigService, $filter) {

  var url = ConfigService.aims.api;

  var users;
  var user;
  var _appRoles = {};
  // var cacheLastUpdated;

  function _getUserByEmail(_users, _email) {
    if (!_users) return false;
    var emails = $filter('where')(_users, { email: _email});
    return emails.length > 0 ? emails[0] : false;
  }

  function getUsers(cleanCache) {
    var deferred = $q.defer();

    if ((!cleanCache) && (users)) {
      deferred.resolve({
        data: users
      });
    } else {
      $http({
        method: 'get',
        url: url + '/users?realm=aimsplatform'
      })
      .then(function(response) {
        users = response.data;
        // cacheLastUpdated = new Date();
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      }).catch(function(exception) {
        deferred.reject({
          exception: exception
        })
      });
    }

    return deferred.promise;
  }

  function getUser(email, cleanCache) {
    var deferred = $q.defer();

    var _user = _getUserByEmail(users, email) || user;

    if ((!cleanCache) && (user)) {
      deferred.resolve({
        data: _user
      });
    } else {
      $http({
        method: 'get',
        url: url + '/users?email=' + email
      })
      .then(function(response) {
        if (response.data.length > 0) {
          user = response.data[0];
          deferred.resolve({
            data: user
          });
        } else {
          deferred.reject({
            error: {
              status: 404,
              message: 'User not found'
            }
          })
        }
      }, function(error) {
        deferred.reject({
          error: error
        });
      }).catch(function(exception) {
        deferred.reject({
          exception: exception
        })
      });
    }

    return deferred.promise;
  }

  function getAppRoles(appName, cleanCache) {
    var deferred = $q.defer();

    if ((!cleanCache) && (_appRoles[appName])) {
      deferred.resolve({
        data: _appRoles[appName]
      });
    } else {
      $http({
        method: 'get',
        url: url + '/roles/apps/' + appName
      })
      .then(function(response) {
        _appRoles[appName] = response.data;
        deferred.resolve({
          data: _appRoles[appName]
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      }).catch(function(exception) {
        deferred.reject({
          exception: exception
        })
      });
    }

    return deferred.promise;
  }

  function getUserAppRoles(userEmail, appName) {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: url + '/roles/users/' + userEmail,
      params: { app: appName }
    })
    .then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(exception) {
      deferred.reject({
        exception: exception
      })
    });

    return deferred.promise;
  }

  // https://gitlab.ubermonitoring.com/aims/aims-platform-api#assign-a-client-role-to-a-user
  function addUserRole(userEmail, clientRole) {
    var deferred = $q.defer();

    $http({
      method: 'post',
      url: url + '/roles/users/' + userEmail,
      data: { clientRole: clientRole }
    })
    .then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(exception) {
      deferred.reject({
        exception: exception
      })
    });

    return deferred.promise;
  }

  // https://gitlab.ubermonitoring.com/aims/aims-platform-api#remove-a-client-role-from-a-user
  function removeUserRole(userEmail, clientRole) {
    var deferred = $q.defer();

    $http({
      method: 'delete',
      url: url + '/roles/users/' + userEmail,
      data: { clientRole: clientRole },
      headers: {'Content-Type': 'application/json;charset=utf-8'}
    })
    .then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(exception) {
      deferred.reject({
        exception: exception
      })
    });

    return deferred.promise;
  }

  return {
    getUsers: getUsers,
    getUser: getUser,
    getAppRoles: getAppRoles,
    getUserAppRoles: getUserAppRoles,
    addUserRole: addUserRole,
    removeUserRole: removeUserRole
  };
})

;

'use strict';

angular.module('aims')

.controller('AccessRolesController', function(Auth, $state, $stateParams, Access, toaster, aimsApps, $i18next) {

  var vm = this;

  vm.userEmailParam = $stateParams.email || null;

  vm.adminAccess = [];
  vm.selectedApp = {
    name: 'none',
    displayName: 'Select an App'
  };

  vm.loadAppsManageablesByMe = function() {
    var appsNames = Auth.user.clientsWithRole('AccessAdmin');
    appsNames.forEach(function(element) {
      aimsApps.getAppInfo(element).then(function(response) {
        vm.adminAccess.push(response.data);
      });
    });
  }

  vm.loadRoles = function() {
    vm.loading = true;
    vm.appRoles = [];
    Access.getAppRoles(vm.selectedApp.name)
    .then(function(response) {
      vm.appRoles = response.data;
      Access.getUserAppRoles(vm.userEmailParam, vm.selectedApp.name)
      .then(function(response) {
        var userRoles = response.data[0].roles;
        angular.forEach(vm.appRoles, function(element) {
          element['assigned'] = userRoles.some(function(x) { return x.name === element.name; });
        });
        vm.originalRoles = angular.copy(vm.appRoles);
      }).finally(function() {
        vm.loading = false;
      });
    });

  }

  vm.selectApp = function(app) {
    vm.selectedApp = app;
    vm.loadRoles();
  }

  vm.loadUser = function() {
    if (!vm.userEmailParam) $state.go('index.adminaccess');

    vm.loading = true;
    Access.getUser(vm.userEmailParam).then(function(response) {
      vm.user = response.data;
    }, function(/* error */) {
      toaster.pop('error', 'Error', 'The user could not be found');
      $state.go('index.adminaccess');
    }).finally(function() {
      vm.loading = false;
    });
  }

  vm.saveChanges = function(changedRoles, userEmail, app) {
    var toResolve = [];
    changedRoles.forEach(function(element) {
      if (element.assigned) {
        toResolve.push(Access.addUserRole(userEmail, app.name + ':' + element.name));
      } else {
        toResolve.push(Access.removeUserRole(userEmail, app.name + ':' + element.name));
      }
    });
    return Promise.all(toResolve);
  }

  vm.saveRoles = function() {
    var rolesChanged = _.differenceWith(vm.appRoles, vm.originalRoles, // eslint-disable-line
      function(x, y) { return x.name === y.name && x.assigned === y.assigned});

    var textConfirm = '<p>' + vm.userEmailParam + '</p>';
    rolesChanged.forEach(function(element){
      textConfirm += 'Role <strong>' + element.name + '</strong> is being <strong>'
        + (element.assigned ? 'added' : 'removed') + '</strong><br />';
    });

    if (rolesChanged.length > 0) {
      swal({ // eslint-disable-line
        title: $i18next.t('roles.pleaseconfirm'),
        html: textConfirm,
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#D1DADE'
      }).then(function () {
        vm.saving = true;
        vm.saveChanges(rolesChanged, vm.userEmailParam, vm.selectedApp)
          .then(function() {
            toaster.pop('success', 'Success', 'The changes were saved');
            vm.saving = false;
            vm.originalRoles = angular.copy(vm.appRoles);
          }, function(/* error */) {
            toaster.pop('error', 'Error', 'Error removing the user. Please try again or contact the Support Team.');
            vm.saving = false;
          });
      }, function() {
        angular.noop();
      });
    }
  }

  vm.removeAllRoles = function(userEmail, app) {
    var toResolve = [];
    vm.appRoles.forEach(function(element) {
      if (element.assigned) {
        toResolve.push(Access.removeUserRole(userEmail, app.name + ':' + element.name));
      }
    });
    return Promise.all(toResolve);
  }

  vm.deleteUser = function() {
    swal({ // eslint-disable-line
      title: $i18next.t('roles.removequestion'),
      text: $i18next.t('roles.removequestionmsg'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c24c47'
    }).then(function () {
      vm.removeAllRoles(vm.userEmailParam, vm.selectedApp)
        .then(function() {
          vm.loadRoles();
          swal( // eslint-disable-line
            $i18next.t('roles.removesuccess'),
            $i18next.t('roles.removesuccessmsg', {
              appName: vm.selectedApp.displayName,
              userEmail: vm.userEmailParam
            }),
            'success'
          );
        }, function(/* error */) {
          toaster.pop('error', 'Error', 'Error removing the user. Please try again or contact the Support Team.')
        });
    }, function() {
      angular.noop();
    });
  }

  vm.init = function() {
    vm.loadUser();
    vm.loadAppsManageablesByMe();
  }
  vm.init();

})

;

'use strict';

angular.module('aims')
.controller('AccessController', function(Auth, $state, $cookies, Access, $scope) {
  var vm = this;

  vm.currentPage = 1;
  vm.pageSize = $cookies.get('aims.accessPageSize') || '10';

  vm.loadUsers = function() {
    vm.loading = true;
    Access.getUsers().then(function(response) {
      vm.users = response.data;
    }).finally(function() {
      vm.loading = false;
    });
  }

  $scope.$watch('access.pageSize', function(newValue, oldValue) {
    if (newValue !== oldValue) $cookies.put('aims.accessPageSize', newValue);
  })

  vm.init = function() {
    vm.loadUsers();
  }
  vm.init();
})

;

(function() {
  'use strict';

  if (window.i18next) {
    // console.log('I18N AVAILABLE');
    window.i18next
      .use(window.i18nextXHRBackend)
      .use(window.i18nextLocalStorageCache);

    window.i18next.init({
      lng: 'en', // If not given, i18n will detect the browser language.
      fallbackLng: 'en',
      backend: {
        loadPath: 'assets/locales/{{lng}}/{{ns}}.json'
      },
      cache: {
        // turn on or off
        enabled: false,
        prefix: 'i18next_res_',
        expirationTime: 7*24*60*60*1000
      }
    }, function(error) {
      if (!error) {
        if (window.i18next.options.resources !== undefined) { // eslint-disable-line
          // If i18next was instantiated in AFC, we need to reload
          // resources in order to load the app translation files
          window.i18next.reloadResources();
        }
        angular.element(document).ready(function() {
          window.setupLogin(null,
          function() {
            angular.bootstrap(document, ['aims']);
          });
        });
      }
    });
  } else {
    // console.log('I18N UNAVAILABLE');
  }


  angular
    .module('aims')
    .run(runBlock);

  /** @ngInject */

  function runBlock($log, $rootScope, $state, aimsPlatform, $i18next, Auth) {
    $rootScope.$state = $state;
    // aimsPlatform.options.appDisplayName = $i18next.t('appdisplayname');
    // aimsPlatform.options.appDisplayDescription = $i18next.t('appdisplaydescription');

    $rootScope.$on('$stateChangeStart', function (event, toState/*, toParams, fromState, fromParams, options*/) { // eslint-disable-line
      switch (toState.name) {
        case 'landing':
        case 'login':
          if (Auth.user.authenticated()) {
            event.preventDefault();
            $state.go('index.dashboard');
          }
          break;
        default:
          if (!Auth.user.authenticated()) {
            event.preventDefault();
            $state.go('landing');
          } else {
            // check for roles
            if (toState.data.protect) {
              if (Auth.user.clientsWithRole(toState.data.protect).length === 0) {
                // You dont have access
                event.preventDefault();
                $state.go('index.dashboard');
              }
            }
          }
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('aims')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('landing', {
        url: "/landing",
        templateUrl: "app/landing/landing.tpl.html",
        controller: 'LandingController as landing',
        data: { specialClass: 'landing-page' }
      })

      .state( 'login', {
        url: '/login',
        template: '<aims-login></aims-login>',
        data:{ pageTitle: 'Login', specialClass: 'login-page' }
      })

      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html"
      })
      .state('index.dashboard', {
        url: "/dashboard",
        templateUrl: "app/dashboard/dashboard.tpl.html",
        controller: 'DashboardController as dash',
        data: { pageTitle: 'Dashboard' }
      })
      .state('index.resources', {
        url: "/resources",
        templateUrl: "app/resources/resources.tpl.html",
        controller: 'ResourcesController as resources',
        data: { pageTitle: 'Resources' }
      })

      .state('index.notifications', {
        url: "/notifications",
        template: '<aims-notifications></aims-notifications>',
        data: { pageTitle: 'Notifications' }
      })
      .state('index.notificationsconfig', {
        url: "/notificationsconfig",
        template: '<aims-notifications-config></aims-notifications-config>',
        data: { pageTitle: 'Notification Configuration' }
      })
      .state('index.support', {
        url: "/support",
        template: '<aims-support></aims-support>',
        data: { pageTitle: 'Support' }
      })
      .state('index.supportdetail', {
        url: "/support/:supportId",
        template: '<aims-support-detail></aims-support-detail>',
        data: { pageTitle: 'Support Detail' }
      })
      .state('index.profile', {
        url: "/profile",
        template: "<aims-profile></aims-profile>",
        data: { pageTitle: 'Profile' }
      })

      .state('admin', {
        abstract: true,
        url: "/admin",
        templateUrl: "app/components/common/content.html"
      })

      .state('admin.access', {
        url: "/access",
        templateUrl: "app/admin/access.tpl.html",
        controller: 'AccessController as access',
        data: {
          pageTitle: 'Access Admin',
          protect: 'AccessAdmin'
        }
      })

      .state('admin.notifier', {
        url: "/notifier",
        templateUrl: "app/admin/notifier.tpl.html",
        controller: 'NotifierController as notifier',
        data: {
          pageTitle: 'Notifier',
          protect: 'NotificationSend'
        }
      })

      .state('admin.roles', {
        url: "/roles/:email",
        templateUrl: "app/admin/access.roles.tpl.html",
        controller: 'AccessRolesController as roles',
        data: {
          pageTitle: 'Roles Admin',
          protect: 'AccessAdmin'
        }
      })

      ;

    $urlRouterProvider.otherwise('/index/dashboard');
  }

})();

'use strict';

angular.module('aims')

.filter('phoneNumber', function() {
  return function(input) {
    if (input === null) return '';
    input += '';
    input = input.replace(/^\+1/, '');
    return '(' + input.slice(0, 3) + ') ' + input.slice(3, 6) + '-' + input.slice(6);
  }
})

.filter('highlight', function($sce) {
  return function(text, phrase) {
    if (!text) {
      return '';
    }
    if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'),
      '<span class="text-highlighted">$1</span>'
    );

    return $sce.trustAsHtml(text)
  }
})

.filter('notificationTypes', function () {
  return function (types, app) {
    app = app || {}
    return types.filter(function (type) {
      return type.app === app.name || !type.app
    })
  }
})

;

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('aims')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-link " href="" ng-click="minimalize()" aria-label="Minimize side menu"><i class="fa fa-bars fa-lg" aria-hidden="true"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive('pageTitle', function($rootScope, $timeout) {
        return {
            link: function(scope, element) {
                var listener = function(event, toState) {
                    // TODO: Default page title if none is defined
                    var title = 'AIMS Platform';
                    // TODO: Create your own title pattern
                    if (toState.data && toState.data.pageTitle) title = toState.data.pageTitle + ' | AIMS';
                    $timeout(function() {
                        element.text(title);
                    });
                };
                $rootScope.$on('$stateChangeStart', listener); // eslint-disable-line
            }
        }
    })
    ;

/**
 * INSPINIA - Responsive Admin Theme
 * 2.7
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

angular.module("aims").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/access.roles.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'roles.title\' | i18next}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'dashboard.title\' | i18next}}</a></li><li class=\"active\"><strong>{{\'roles.nav\' | i18next}}</strong></li></ol></div></div><div class=\"row wrapper border-bottom gray-bg\"><div class=\"col-lg-9\"><div class=\"p-xs\" style=\"padding-left: 0;\"><a href=\"\" ui-sref=\"admin.access\" class=\"btn btn-link\"><i class=\"fa fa-arrow-left fa-fw\"></i> {{\'backto\' | i18next}} {{\'access.nav\' | i18next}}</a></div></div></div><div class=\"row wrapper wrapper-content\" ng-cloak=\"\"><div class=\"col-md-4\"><div class=\"navy-bg p-lg\"><div class=\"m-b-md\"><h2 class=\"font-bold no-margins\">{{ roles.user.name || roles.user.email }}</h2><span>{{ roles.user.email }}</span></div><div><span class=\"block\" ng-if=\"roles.user.phoneNumber\"><i class=\"fa fa-phone fa-fw\" aria-hidden=\"true\"></i> {{roles.user.phoneNumber | phoneNumber}}</span> <span class=\"block\" ng-if=\"roles.user.address\"><address-format address=\"roles.user.address\"></address-format></span></div></div><div class=\"widget-text-box\"><div><h5>{{\'roles.manageroles\' | i18next}}</h5><div class=\"btn-group\" uib-dropdown=\"\" is-open=\"status.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\">{{roles.selectedApp.displayName | characters:30}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" ng-repeat=\"app in roles.adminAccess | orderBy:\'displayName\'\" class=\"m-sm\"><a ng-click=\"roles.selectApp(app)\"><img ng-src=\"{{app.logo}}\" height=\"40px\" width=\"40px\" style=\"margin-right: 10px;\"><h2 style=\"display: inline-block; vertical-align: middle;\">{{ app.displayName }}</h2></a></li></ul></div></div></div></div><div class=\"col-md-8\" ng-if=\"roles.selectedApp.name !== \'none\'\"><div class=\"ibox\"><div class=\"ibox-title\"><img ng-src=\"{{roles.selectedApp.logo}}\" height=\"40px\" style=\"margin-right: 10px;\"><h2 style=\"display: inline-block; vertical-align: middle;\">{{ roles.selectedApp.displayName }} Roles</h2></div><div class=\"ibox-content p-lg\"><div><div class=\"feed-activity-list m-l-md m-r-md\" ng-if-start=\"!roles.loading\"><div class=\"feed-element\" ng-repeat=\"role in roles.appRoles\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-info btn-outline btn-xs\" style=\"padding: 6px;\" ng-model=\"role.assigned\" uib-btn-checkbox=\"\" uib-btn-checkbox-true=\"1\" uib-btn-checkbox-false=\"0\"><i class=\"fa fa-lg fa-fw\" ng-class=\"{\'fa-check\': role.assigned}\" aria-hidden=\"true\"></i></button></div><div class=\"media-body\"><strong>{{role.name}}</strong><br><span>{{role.description}}</span></div></div></div><div class=\"m-t-lg\" ng-if-end=\"\"><button class=\"btn btn-primary\" ng-click=\"roles.saveRoles()\" ng-disabled=\"roles.saving\">{{(roles.saving ? \'roles.saving\' : \'roles.save\') | i18next}}</button> <button class=\"btn btn-danger pull-right\" ng-click=\"roles.deleteUser()\" ng-disabled=\"roles.saving\">{{\'roles.removeuser\' | i18next:{appName: roles.selectedApp.displayName} }}</button></div><load-spinner size=\"sm\" ng-if=\"roles.loading\">{{\'roles.loading\' | i18next}}</load-spinner></div></div></div></div></div>");
$templateCache.put("app/admin/access.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>App Access Management</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'dashboard.title\' | i18next}}</a></li><li class=\"active\"><strong>Access Admin</strong></li></ol></div></div><div class=\"row wrapper wrapper-content\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h3>{{\'access.aimsusers\' | i18next}}</h3></div><div class=\"ibox-content ibox-heading\"><div class=\"row\"><div class=\"col-sm-6 pull-right\"><search-box model=\"access.search\" placeholder=\"{{\'access.search\' | i18next}}...\" aria=\"{{\'access.search\' | i18next}}\" size=\"md\"></search-box></div></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"!access.loading\"><div class=\"table-responsive\" ng-if=\"(access.users | filterBy: [\'name\', \'email\', \'phoneNumber\']: access.search).length > 0\"><table class=\"table table-hover table-striped\"><thead><tr><th>{{\'access.name\' | i18next}}</th><th>{{\'access.email\' | i18next}}</th><th>{{\'access.phone\' | i18next}}</th><th class=\"text-right\">{{\'access.lastupdate\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in access.users | filterBy: [\'name\', \'email\', \'phoneNumber\']: access.search | orderBy:\'name\' | limitTo:access.pageSize:((access.currentPage-1)*access.pageSize)\"><td ng-bind-html=\"user.name | highlight:access.search\"></td><td ng-bind-html=\"user.email | highlight:access.search\"></td><td>{{user.phoneNumber | phoneNumber}}</td><td class=\"text-right\">{{user.updated_at | date:\'MMM d, yyyy hh:mm a\'}}</td><td class=\"text-right\"><a class=\"btn btn-success btn-xs\" ui-sref=\"admin.roles({email: user.email})\">{{\'access.edit\' | i18next}}</a></td></tr></tbody><tfoot><tr><td class=\"text-center\" colspan=\"5\"><div class=\"pull-left m-t-md\"><select ng-model=\"access.pageSize\" aria-label=\"Select page size\" class=\"form-control input-sm\"><option value=\"10\">{{\'page.s10\' | i18next}}</option><option value=\"20\">{{\'page.s20\' | i18next}}</option><option value=\"50\">{{\'page.s50\' | i18next}}</option><option value=\"100\">{{\'page.s100\' | i18next}}</option></select></div><ul uib-pagination=\"\" total-items=\"(access.users | filterBy: [\'name\', \'email\', \'phoneNumber\']: access.search).length\" ng-model=\"access.currentPage\" max-size=\"5\" items-per-page=\"access.pageSize\" boundary-links=\"true\" force-ellipses=\"true\" first-text=\"{{\'page.first\' | i18next}}\" previous-text=\"{{\'page.previous\' | i18next}}\" next-text=\"{{\'page.next\' | i18next}}\" last-text=\"{{\'page.last\' | i18next}}\"></ul></td></tr></tfoot></table></div><div ng-if=\"(access.users | filterBy: [\'name\', \'email\', \'phoneNumber\']: access.search).length === 0 && access.search\"><empty-list icon=\"fa-search\">{{\'access.norecords\' | i18next}} <strong>\"{{access.search}}\"</strong></empty-list></div><div ng-if=\"access.users.length === 0 && !access.search\"><empty-list icon=\"fa-users\">{{\'access.nousers\' | i18next}}</empty-list></div></div><div class=\"col-lg-12\" ng-if=\"access.loading\"><load-spinner size=\"md\">{{\'access.loading\' | i18next}}</load-spinner></div></div></div></div></div></div>");
$templateCache.put("app/admin/notifier.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'notifier.title\' | i18next}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'dashboard.title\' | i18next}}</a></li><li class=\"active\"><strong>{{\'notifier.title\' | i18next}}</strong></li></ol></div></div><div class=\"row wrapper wrapper-content\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h3>{{\'notifier.title\' | i18next}}</h3></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"!notifier.loading\"><form ng-submit=\"notifier.sendBulk()\" autocomplete=\"off\"><div class=\"form-group\"><label for=\"app\">{{\'notifier.to\' | i18next}}</label><select ng-required=\"true\" ng-model=\"notifier.formData.app\" id=\"app\" ng-options=\"app.displayName for app in notifier.apps track by app.name\" class=\"form-control input-sm\"></select></div><div class=\"form-group\"><label for=\"type\">{{\'notifier.type\' | i18next}}</label><select ng-required=\"true\" ng-model=\"notifier.formData.type\" id=\"type\" ng-options=\"type.displayName for type in notifier.types | notificationTypes:notifier.formData.app track by type.name\" class=\"form-control input-sm\"></select></div><div class=\"form-group\"><label for=\"subject\">{{\'notifier.subject\' | i18next}}</label> <input ng-required=\"true\" ng-model=\"notifier.formData.title\" id=\"subject\" type=\"text\" class=\"form-control imput-sm\"></div><div class=\"form-group\"><label for=\"content\">{{\'notifier.body\' | i18next}}</label> <textarea ng-required=\"true\" class=\"form-control imput-sm\" ng-model=\"notifier.formData.content\" id=\"content\" rows=\"4\" style=\"resize: none;\"></textarea></div><button type=\"submit\" id=\"send\" ng-disabled=\"notifier.sending\" class=\"btn btn-danger btn-lg pull-right\">{{\'notifier.send\' | i18next}}</button></form></div><div class=\"col-lg-12\" ng-if=\"notifier.loading\"><load-spinner size=\"md\">{{\'notifier.loading\' | i18next}}</load-spinner></div></div><div class=\"row\"><div class=\"col-lg-12 notifier-error-messages\" ng-if=\"notifier.errorMessages.length\"><div class=\"notifier-error-header\">Error Messages ({{notifier.errorMessages.length}})</div><div ng-repeat=\"errorMessage in notifier.errorMessages\" class=\"notifier-error-message\">{{errorMessage}}</div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/dashboard.tpl.html","<div class=\"row border-bottom white-bg dashboard-header\"><div class=\"col-sm-12\"><h2>{{\'dashboard.welcome\' | i18next:{name: dash.userProfile.name} }}</h2>{{\'dashboard.notification\' | i18next:{count: dash.allUnread} }}</div></div><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12 text-center\" ng-if=\"dash.appsLoading\"><load-spinner size=\"lg\">{{\'dashboard.appsloading\' | i18next}}</load-spinner></div><div class=\"col-lg-12 text-center\" ng-if=\"!dash.appsLoading && dash.appsError\"><div style=\"height: 100px;\" class=\"m-b-lg text-danger\"><h2>{{\'dashboard.appserror\' | i18next}}</h2></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\" ng-repeat=\"app in dash.apps\" ng-if=\"!dash.appsLoading && !dash.appsError\"><div class=\"ibox\"><div class=\"ibox-content app-box\"><img alt=\"{{ app.displayName }}\" ng-src=\"{{ app.logo }}\" height=\"70px\" class=\"m-b-sm\"><div style=\"height: 60px; overflow: auto;\"><h2>{{ app.displayName }}</h2></div><a class=\"btn btn-default btn-sm m-t-sm\" ng-href=\"{{ app.url }}\"><span class=\"m-l-sm m-r-sm text-uppercase\">{{\'dashboard.open\' | i18next}}</span></a></div></div></div></div><div class=\"row\"><div class=\"col-md-12 col-lg-6\"><div class=\"ibox\"><div class=\"ibox-title\"><h3>{{\'afc.notification.title\' | i18next}} <small class=\"m-l-md\"><a ui-sref=\"index.notifications\" class=\"text-normal text-uppercase\">{{\'dashboard.viewall\' | i18next}}</a></small></h3></div><div class=\"ibox-content\" style=\"padding-top: 0px;\"><div class=\"table-responsive\" ng-if=\"!dash.notificationsLoading && !dash.notificationsError\"><table class=\"table table-hover issue-tracker\"><tbody><tr ng-repeat=\"notification in dash.notifications\"><td class=\"text-right\" width=\"10px\"><span style=\"white-space: nowrap;\">{{ dash.apps[notification.app].displayName || notification.app | uppercase }}</span> &nbsp;</td><td class=\"text-center\" ng-class=\"notification.type | typeClass:\'text\'\" width=\"10px\"><i class=\"fa fa-lg fa-fw\" ng-class=\"notification.type | typeIcon:\'fa\'\" uib-tooltip=\"{{ notification.type | uppercase }}\"></i></td><td class=\"issue-info\"><a href=\"\">{{ notification.title }}</a><br><span>{{ notification.content }}</span></td><td class=\"text-right\">{{ notification.created_at | relatify }}</td><td class=\"text-center text-navy\" width=\"50px\"><i class=\"fa fa-circle fa-lg\" aria-hidden=\"true\" ng-if=\"notification.read === 0\" uib-tooltip=\"{{\'afc.notification.unread\' | i18next}}\"></i> <i class=\"fa fa-circle-o fa-lg\" aria-hidden=\"true\" ng-if=\"notification.read !== 0\" uib-tooltip=\"{{\'afc.notification.read\' | i18next}}\"></i></td></tr></tbody></table></div><div class=\"m-lg text-center text-danger\" ng-if=\"!dash.notificationsLoading && dash.notificationsError\"><span>{{\'dashboard.notificationserror\' | i18next}}</span></div><div ng-if=\"dash.notifications.length === 0 && !dash.notificationsLoading && !dash.notificationsError\"><div class=\"text-center m-t-md m-b-lg\"><i class=\"fa fa-bell fa-5x text-ultramuted m-b-sm\" aria-hidden=\"true\"></i><br>{{\'afc.notification.clear\' | i18next}}</div></div><load-spinner size=\"sm\" ng-if=\"dash.notificationsLoading\"></load-spinner></div></div></div><div class=\"col-md-12 col-lg-6\"><div class=\"ibox\"><div class=\"ibox-title\"><h3>{{\'afc.support.title\' | i18next}} <small class=\"m-l-md\"><a ui-sref=\"index.support\" class=\"text-normal text-uppercase\">{{\'dashboard.viewall\' | i18next}}</a></small></h3></div><div class=\"ibox-content\" style=\"padding-top: 0px;\"><div class=\"table-responsive\" ng-if=\"!dash.issuesLoading && !dash.issuesError\"><table class=\"table table-hover issue-tracker\"><tbody><tr ng-repeat=\"issue in dash.issues | orderBy:\'-fields.updated\' | limitTo:10\"><td style=\"width: 1%;\"><img ng-src=\"{{ issue.fields.status.iconUrl }}\" ng-if=\"issue.fields.status.iconUrl | endsWith: \'.png\'\"></td><td style=\"width: 1%;\"><span class=\"label\" ng-class=\"issue.fields.status.statusCategory.name | statusClass:\'label\'\" uib-tooltip=\"{{ issue.fields.status.description }}\" tooltip-placement=\"right\">{{ issue.fields.status.name }}</span></td><td class=\"issue-info\">{{ issue.key }} <small>{{ issue.fields.description}}</small></td><td style=\"width: 1%;\"><span style=\"white-space: nowrap;\">{{ issue.fields.updated | momentify }}</span><br><small style=\"white-space: nowrap;\">{{\'afc.support.created\' | i18next:{date: (issue.fields.created | relatify)} }}</small></td></tr></tbody></table></div><div class=\"m-lg text-center text-danger\" ng-if=\"!dash.issuesLoading && dash.issuesError\"><span>{{\'dashboard.issueserror\' | i18next}}</span></div><div ng-if=\"dash.issues.length === 0 && !dash.issuesLoading && !dash.issuesError\"><div class=\"text-center m-t-md m-b-lg\"><i class=\"fa fa-life-ring fa-5x text-ultramuted m-b-sm\" aria-hidden=\"true\" style=\"\"></i><br>{{\'afc.support.clear\' | i18next}}</div></div><load-spinner size=\"sm\" ng-if=\"dash.issuesLoading\"></load-spinner></div></div></div></div></div>");
$templateCache.put("app/landing/landing.tpl.html","<aims-top-navbar enable-menu=\"false\" app-title=\"AIMS\" app-name=\"aims\"></aims-top-navbar><div class=\"row banner_message_row\"><div class=\"container text-center\"><p class=\"banner_message\">New customers interested in the AIMS Centralized ELR Solution please complete the <a href=\"https://app.smartsheet.com/b/form/ad9f42bb79b8486f8755e69d51214ec7\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"banner_message_link\">Customer Interest Form Here</a>. Please direct questions or requests for additional information to our <a href=\"mailto:Customer%20Success%20%3cCustomer.Success@aphl.org%3e\" class=\"banner_message_link\">Customer Success inbox</a></p></div></div><div class=\"home-hero\"><div class=\"hero-title\"><strong>APHL</strong> Informatics Messaging Services</div></div><div class=\"little-space\"></div><div class=\"pelorus-ribbon\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"three-cat\"><img src=\"assets/images/landing/3portalicons2.png\" height=\"110px;\" alt=\"Secured\"> <span class=\"three-title text-uppercase\">{{\'landing.secure\' | i18next}}</span><p class=\"standout\">{{\'landing.securetext\' | i18next}}</p></div></div><div class=\"col-md-4\"><div class=\"three-cat\"><img src=\"assets/images/landing/3portalicons1.png\" height=\"110px;\" alt=\"{{\'landing.cloud\' | i18next}}\"> <span class=\"three-title text-uppercase\">{{\'landing.cloud\' | i18next}}</span><p class=\"standout\">{{\'landing.cloudtext\' | i18next}}</p></div></div><div class=\"col-md-4\"><div class=\"three-cat\"><img src=\"assets/images/landing/3portalicons3.png\" height=\"110px;\" alt=\"{{\'landing.data\' | i18next}}\"> <span class=\"three-title text-uppercase\">{{\'landing.data\' | i18next}}</span><p class=\"standout\">{{\'landing.datatext\' | i18next}}</p></div></div></div></div></div></div></div><div class=\"greystripe\"><div class=\"container text-center\"><div class=\"row m-t-lg\"><div class=\"col-lg-12\"><h1 class=\"text-uppercase\">{{\'landing.apps\' | i18next}}</h1></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"apps-box\"><div class=\"apps-box-content\"><img src=\"assets/images/landing/apps/aims.png\" alt=\"{{\'landing.aims\' | i18next}}\" height=\"70px\"></div><div class=\"apps-box-text\"><h4 style=\"margin-top: 25px\">{{\'landing.aims\' | i18next}}</h4>{{\'landing.aimstext\' | i18next}}</div></div></div><div class=\"col-md-4\"><div class=\"apps-box\"><div class=\"apps-box-content\"><img src=\"assets/images/landing/apps/rabies.png\" alt=\"{{\'landing.rabies\' | i18next}}\" height=\"70px\"></div><div class=\"apps-box-text\"><h4 style=\"margin-top: 25px\">{{\'landing.rabies\' | i18next}}</h4>{{\'landing.rabiestext\' | i18next}}</div></div></div><div class=\"col-md-4\"><div class=\"apps-box\"><div class=\"apps-box-content\" style=\"height: 70px; position: relative\"><img src=\"assets/images/landing/apps/mt.png\" alt=\"{{\'landing.mt\' | i18next}}\" class=\"img-responsive\" style=\"position: absolute; bottom: 30%\"></div><div class=\"apps-box-text\"><h4 style=\"margin-top: 25px\">{{\'landing.mt\' | i18next}}</h4>{{\'landing.mttext\' | i18next}}</div></div></div></div><div class=\"row\" style=\"margin-bottom: 100px\"><div class=\"col-md-4\"><div class=\"apps-box\"><div class=\"apps-box-content\"><img src=\"assets/images/landing/apps/steve.png\" alt=\"{{\'landing.steve\' | i18next}}\" height=\"70px\"></div><div class=\"apps-box-text\"><h4 style=\"margin-top: 25px\">{{\'landing.steve\' | i18next}}</h4>{{\'landing.stevetext\' | i18next}}</div></div></div><div class=\"col-md-4\"><div class=\"apps-box\"><div class=\"apps-box-content\" style=\"height: 70px; position: relative\"><img src=\"assets/images/landing/apps/rp.png\" alt=\"{{\'landing.rp\' | i18next}}\" height=\"70px\" class=\"img-responsive\" style=\"position: absolute; bottom: 30%\"></div><div class=\"apps-box-text\"><h4 style=\"margin-top: 25px\">{{\'landing.rp\' | i18next}}</h4>{{\'landing.rptext\' | i18next}}</div></div></div><div class=\"col-md-4\"><div class=\"apps-box\"><div class=\"apps-box-content\" style=\"position: relative\"><div class=\"app-new\">NEW!</div><img src=\"assets/images/landing/apps/VALIDATORLOGO.png\" alt=\"{{\'landing.validator\' | i18next}}\" height=\"70px\"></div><div class=\"apps-box-text\"><h4 style=\"margin-top: 25px\">{{\'landing.validator\' | i18next}}</h4>{{\'landing.validatortext\' | i18next}}<div class=\"m-t-md\"><a class=\"btn btn-danger\" ng-href=\"{{ landing.validatorOnline }}\" target=\"_blank\">Open</a></div></div></div></div></div></div></div><div class=\"partners-ribbon\"><span class=\"partners-title\" ng-click=\"landing.collapseToggle()\">{{\'landing.partners\' | i18next}}</span><br><a href=\"\" class=\"partners-btn\" ng-click=\"landing.collapseToggle()\" aria-label=\"{{\'landing.partnersaction\' | i18next}}\"><i class=\"fa\" ng-class=\"{\'fa-chevron-down\': landing.pCollapsed, \'fa-chevron-up\': !landing.pCollapsed}\"></i></a></div><div class=\"partners-expanded\" ng-class=\"{collapse: landing.pCollapsed}\"><div class=\"thin-line\"></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1\"><h4 class=\"partners-subtitle\" style=\"margin-top: 50px\">{{\'landing.partnerssubtitle\' | i18next}}</h4><div class=\"partners-text\"><ul><li>Alabama Bureau of Clinical Laboratories</li><li>Alabama Department of Public Health</li><li>Alaska Department of Health and Social Services</li><li>Alaska Public Health Laboratory</li><li>Arizona Department of Health</li><li>Arizona State Health Laboratory</li><li>Arkansas Department of Public Health</li><li>Arkansas Public Health Laboratory</li><li>California Cancer Registry</li><li>California Department of Public Health</li><li>California Office of the State Public Health Laboratory</li><li>Centers for Disease Control</li><li>Colorado Department of Public Health and Environment</li><li>Colorado Public Health Laboratory</li><li>Connecticut Department of Public Health</li><li>Connecticut State Public Health Laboratory</li>DC Public Health Department<li>DC Public Health Laboratory</li><li>Delaware Health and Social Services</li><li>Delaware Public Health Laboratory</li><li>Florida Bureau of Public Health Laboratories</li><li>Florida Department of Health</li><li>Georgia Department of Public Health</li><li>Georgia Public Health Laboratory</li><li>Guam Department of Health</li><li>Hawaii Department of Health</li><li>Hawaii Public Health & Environmental Laboratories</li><li>Houston Department of Health and Human Services - Bureau of Laboratory Services</li><li>Idaho Bureau of Laboratories</li><li>Idaho Department of Health and Welfare</li><li>Illinois Department of Health</li><li>Illinois Division of Public Laboratories</li><li>Indiana Centers for Disease Control</li><li>Indiana State Department of Health Laboratories</li><li>Iowa Department of Public Health</li><li>Iowa State Hygienic Laboratory</li><li>Kansas Department of Health</li><li>Kansas Health & Environmental Labs</li><li>Kansas State University</li><li>Kentucky Division of Laboratory Services</li><li>Kentucky: Cabinet for Health and family Services</li>LA County Public Health Laboratory<li>Los Angeles County</li><li>Louisiana Department of Health</li><li>Louisiana Office of Public Health Laboratory</li><li>Maine Centers for Disease Control</li><li>Maine Health and Environmental Testing Laboratory</li><li>Marshall Islands</li><li>Maryland Department of Health and Mental Hygiene</li><li>Maryland DHMH Laboratories Administration</li><li>Massachusetts Department of Public Health</li><li>Massachusetts State Public Health Laboratory Services</li><li>Michigan Bureau of Laboratories</li><li>Michigan Department of Health and Human Services</li><li>Minnesota Department of Health</li><li>Minnesota Public Health Laboratory</li><li>Mississippi Public Health Laboratory</li><li>Mississippi State Department of Health</li><li>Missouri Department of Health and Senior Services</li><li>Missouri State Public Health Laboratory</li><li>Montana Department of Public Health & Human Services</li><li>Montana Public Health Laboratory</li><li>Naval Health Research Center</li><li>Naval Research Laboratory</li><li>Nebraska Department of Health and Human Services</li><li>Nebraska Public Health Laboratory</li><li>Nevada Division of Public and Behavioral Health</li><li>Nevada State Public Health Laboratory</li><li>New Hampshire Department of Health and Human Services</li><li>New Hampshire Public Health Laboratories</li><li>New Jersey Department of Health</li><li>New Jersey Public Health and Environmental Laboratories</li><li>New Mexico Department of Health</li><li>New Mexico Department of Health Scientific Laboratory</li><li>New York City Department of Health and Mental Hygiene</li><li>New York City Department of Health and Mental Hygiene - PHL</li><li>New York Public Health Laboratory</li><li>New York State Department of Health</li><li>North Carolina Department of Health and Human Services</li><li>North Carolina State Laboratory of Public Health</li><li>North Dakota Department of Health</li><li>North Dakota Department of Health Laboratory Services</li><li>Northern Mariana Islands</li><li>Ohio Bureau of Public Health Laboratory</li>Ohio Department of Health<li>Oklahoma Public Health Laboratory</li><li>Oklahoma State Department of Health</li><li>Oregon Public Health Division</li><li>Oregon State Public Health Laboratory</li><li>Pennsylvania Bureau of Laboratories</li><li>Pennsylvania Health and Human Services</li><li>Philadelphia</li><li>Puerto Rico Department of Health</li><li>Puerto Rico Public Health Laboratory</li><li>Rhode Island Department of Health</li><li>Rhode Island Department of Health Laboratory</li><li>San Diego County</li><li>San Diego Public Health Laboratory</li><li>San Luis Obispo County Public Health Department</li><li>Solano County</li><li>South Carolina Centers for Disease Control</li><li>South Carolina Public Health Laboratory</li><li>South Dakota Department of Health</li><li>South Dakota Public Health Laboratory</li><li>Southern Nevada Health District</li><li>Tennessee Department of Health</li><li>Tennessee State Public Health Laboratory</li><li>Texas Department of State Health Services</li><li>Texas Department Of State Health Services Public Health Laboratory</li><li>United States Air Force: Wright Patterson Air Force Base</li><li>Utah Department of Public Health</li><li>Utah Public Health Laboratory</li><li>Vermont Department of Public Health</li><li>Vermont Public Health Laboratory</li><li>Virgin Islands Department of Health</li><li>Virgin Islands Public Health Laboratory</li><li>Virginia Department of Health</li><li>Virginia Division of Consolidated Laboratory Services</li><li>Washington State Department of Health</li><li>Washington State Department of Health Public Health Laboratories</li><li>West Virginia Bureau for Public Health</li><li>West Virginia Office of Laboratory Services</li><li>Wisconsin Division of Public Health</li><li>Wisconsin State Hygiene Laboratory</li><li>Wyoming Department of Health</li><li>Wyoming Public Health Laboratory</li></ul><h4>{{\'landing.commercialpartners\' | i18next}}</h4><ul><li>Abbott Informatics</li><li>Advocate Aurora Health</li><li>AltaMed</li><li>CHW</li><li>Community Medical</li><li>Confluence Health</li><li>Contra Costa Health</li><li>Dxterity</li><li>eHxHUB</li><li>EMC</li><li>eTrueNorth</li><li>Gundersen Health</li><li>Health First</li><li>Helix</li><li>Hospital Sisters Health System</li><li>Houston Methodist</li><li>Indian Health Services</li><li>Institute for Family Health</li><li>Intermountain</li><li>John Muir Health</li><li>KHIE</li><li>Lee Memorial</li><li>Leon Medical Centers</li><li>Memorial Care</li><li>Metro Health</li><li>MHS</li><li>MiHIN</li><li>NCHIE</li><li>NYC Health & Hospitals</li><li>OCHIN</li><li>Peace Health</li><li>Physician Network</li><li>Premise Health</li><li>Quest Diagnostics Headquarters</li><li>Quest Diagnostics - Nichols Institute</li><li>Sanford Health</li><li>Scott & White/Baylor</li><li>Skagit Regional Health</li><li>Sports Drug Testing Lab</li><li>St. Elizabeth</li><li>Stanford HealthCare</li><li>Sutter Health</li><li>Tempus Labs</li><li>ThedaCare</li><li>UC Health</li><li>UCDavis</li><li>UCLA Health</li><li>UCSD Health</li><li>UCSF Medical Center</li><li>UHS</li><li>UNC</li><li>Vidant Health</li><li>Watson Clinic</li><li>WHHS</li></ul></div></div></div></div></div><div class=\"white-ribbon\"><div class=\"hidden-xs hidden-sm some-space\"></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-5 col-md-offset-1 text-left\"><div class=\"video-text\"><span class=\"video-title\">{{\'landing.videotitle\' | i18next}}</span><p>{{\'landing.videotext\' | i18next}}</p><p>{{\'landing.videopromo\' | i18next}}</p><div class=\"row\" style=\"margin-top: 30px\"><div class=\"col-sm-6\"><a href=\"https://www.youtube.com/watch?v=8k28zW0Yzyw\" class=\"btn btn-danger\"><i class=\"fa fa-youtube-play fa-lg\" aria-hidden=\"true\" style=\"margin-right: 5px\"></i> {{\'landing.watch\' | i18next}}</a><p class=\"video-subtext\">{{\'landing.video4\' | i18next}}</p></div><div class=\"col-sm-6\"><a href=\"https://www.youtube.com/v/JB27oBJVE6s\" class=\"btn btn-danger\"><i class=\"fa fa-youtube-play fa-lg\" aria-hidden=\"true\" style=\"margin-right: 5px\"></i> {{\'landing.watch\' | i18next}}</a><p class=\"video-subtext\">{{\'landing.video3\' | i18next}}</p></div></div><div class=\"row\" style=\"margin-top: 20px\"><div class=\"col-sm-6\"><a href=\"https://www.youtube.com/watch?v=63G1i-9T78Q&feature=youtu.be\" class=\"btn btn-danger\"><i class=\"fa fa-youtube-play fa-lg\" aria-hidden=\"true\" style=\"margin-right: 5px\"></i> {{\'landing.watch\' | i18next}}</a><p class=\"video-subtext\">{{\'landing.video2\' | i18next}}</p></div><div class=\"col-sm-6\"><a href=\"https://www.youtube.com/watch?v=KplVw0t3oMc\" class=\"btn btn-danger\"><i class=\"fa fa-youtube-play fa-lg\" aria-hidden=\"true\" style=\"margin-right: 5px\"></i> {{\'landing.watch\' | i18next}}</a><p class=\"video-subtext\">{{\'landing.video1\' | i18next}}</p></div></div></div></div><div class=\"col-md-5\"><div class=\"embed-responsive embed-responsive-16by9\"><iframe class=\"embed-responsive-item\" title=\"Featured video\" src=\"https://www.youtube.com/embed/8k28zW0Yzyw\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div></div><div class=\"hidden-xs hidden-sm some-space\"></div></div><div class=\"resource-ribbon\"><div class=\"container\"><div class=\"row\" style=\"margin-bottom: 50px\"><div class=\"col-lg-12 text-center m-t-lg m-b-lg\"><h1>{{\'landing.resourcestitle\' | i18next}}</h1></div></div><div class=\"row\" ng-repeat=\"row in landing.resources | orderBy:\'order\' | chunkBy:2\"><div class=\"col-md-6\" ng-repeat=\"res in row\"><div class=\"row\"><div class=\"col-xs-4\"><img src=\"assets/images/landing/resource-art.png\" class=\"img-responsive\"></div><div class=\"col-xs-8 sidestripe\"><h3>{{ res.title }}</h3><p>{{ res.description }}</p><a class=\"btn btn-danger text-uppercase\" ng-href=\"assets/resources/{{res.source}}.pdf\" download=\"\">{{\'landing.download\' | i18next}}</a></div></div></div></div></div></div><div class=\"greystripe\"><div class=\"container-fluid contact\" ng-controller=\"ContactFormController as contact\"><span class=\"video-title m-t-lg\">{{\'landing.contactus\' | i18next}}</span><div class=\"col-md-4 col-md-offset-4 m-b-lg\"><form ng-submit=\"contact.processForm()\" autocomplete=\"off\" ng-hide=\"contact.submitted\"><div class=\"form-group\"><label for=\"yourname\">{{\'landing.name\' | i18next}}</label> <input ng-model=\"contact.formData.name\" id=\"yourname\" type=\"text\" class=\"form-control imput-sm\" required=\"\"></div><div class=\"form-group\"><label for=\"email\">{{\'landing.email\' | i18next}}</label> <input required=\"\" ng-model=\"contact.formData.email\" id=\"email\" type=\"email\" class=\"form-control imput-sm\"></div><div class=\"form-group\"><label for=\"message\">{{\'landing.message\' | i18next}}</label> <textarea class=\"form-control imput-sm\" ng-model=\"contact.formData.message\" id=\"message\" rows=\"4\" style=\"resize: none\"></textarea></div><button type=\"submit\" id=\"send\" class=\"btn btn-danger btn-lg pull-right\">{{\'landing.submit\' | i18next}}</button></form><div ng-show=\"contact.submitted\" class=\"text-center\"><a class=\"pointer\" ng-click=\"contact.submitted=false\">{{\'landing.thankyou\' | i18next}}</a></div></div></div></div><footer class=\"footer\" style=\"position: relative\"><div class=\"text-center\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><a href=\"https://www.facebook.com/PublicHealthLabs/\" target=\"_blank\" aria-label=\"{{\'landing.facebook\' | i18next}}\"><img class=\"footer-social\" src=\"assets/images/landing/social-facebook.png\" alt=\"{{\'landing.facebook\' | i18next}}\"></a> <a href=\"https://twitter.com/APHL?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr\" target=\"_blank\" aria-label=\"{{\'landing.twitter\' | i18next}}\"><img class=\"footer-social\" src=\"assets/images/landing/social-tweeter.png\" alt=\"{{\'landing.twitter\' | i18next}}\"></a> <a href=\"https://www.linkedin.com/company/association-of-public-health-laboratories-aphl\" target=\"_blank\" aria-label=\"{{\'landing.linkedin\' | i18next}}\"><img class=\"footer-social\" src=\"assets/images/landing/social-linkedin.png\" alt=\"{{\'landing.linkedin\' | i18next}}\"></a> <a href=\"https://www.youtube.com/user/aphlvideo/featured\" target=\"_blank\" aria-label=\"{{\'landing.youtube\' | i18next}}\"><img class=\"footer-social\" src=\"assets/images/landing/social-youtube.png\" alt=\"{{\'landing.youtube\' | i18next}}\"></a></div><div class=\"col-md-2\"><div class=\"footer-text\">{{\'landing.supportemail\' | i18next}}</div></div><div class=\"col-md-2 hidden-sm hidden-xs\"><div class=\"footer-text text-right\">{{\'landing.phone\' | i18next}}</div></div><div class=\"col-md-2 hidden-md hidden-lg\"><div class=\"footer-text\">{{\'landing.phone\' | i18next}}</div></div><div class=\"col-md-4\"><a href=\"https://ruvos.com\" target=\"_blank\" aria-label=\"{{\'landing.poweredby\' | i18next}}\"><img class=\"ruvos-logo\" src=\"assets/images/landing/ruvos-blue-logo.png\" alt=\"{{\'landing.poweredby\' | i18next}}\"></a></div></div></div></div></footer>");
$templateCache.put("app/resources/resources.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'resources.title\' | i18next}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'dashboard.title\' | i18next}}</a></li><li class=\"active\"><strong>{{\'resources.nav\' | i18next}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content blog\"><div class=\"row\"><div class=\"col-sm-6 col-md-4 col-lg-4 pull-right\"><search-box model=\"resources.search\" placeholder=\"{{\'resources.search\' | i18next}}...\" aria=\"{{\'resources.search\' | i18next}}\" size=\"md\"></search-box></div></div><div class=\"row m-t-md\"><div class=\"col-lg-6\" ng-repeat=\"res in resources.resources | orderBy:\'order\' | filterBy: [\'title\', \'description\']: resources.search\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"feed-element\" style=\"padding: 3px;\"><div class=\"pull-left\" style=\"margin-right: 20px; margin-left: 10px;\"><a ng-href=\"assets/resources/{{res.source}}.pdf\" target=\"_blank\"><div class=\"thumbnail-pdf\"><img ng-src=\"assets/resources/thumbs/{{res.source}}.jpeg\" height=\"250px\"></div></a></div><div class=\"media-body\"><h3 ng-bind-html=\"res.title | highlight:resources.search\"></h3><p ng-bind-html=\"res.description | highlight:resources.search\"></p><a class=\"btn btn-default text-uppercase\" ng-href=\"assets/resources/{{res.source}}.pdf\" target=\"_blank\">{{\'resources.view\' | i18next}}</a> <a class=\"btn btn-danger text-uppercase\" ng-href=\"assets/resources/{{res.source}}.pdf\" download=\"\">{{\'landing.download\' | i18next}}</a></div></div></div></div></div></div></div><div class=\"row m-t-md\" ng-if=\"(resources.resources | filterBy: [\'title\', \'description\']: resources.search).length === 0 && resources.search\"><div class=\"col-lg-12\"><empty-list icon=\"fa-search\">{{\'resources.norecords\' | i18next}} <strong>\"{{resources.search}}\"</strong></empty-list></div></div></div>");
$templateCache.put("app/components/common/addressFormat.tpl.html","<i class=\"fa fa-map-marker fa-fw\" aria-hidden=\"true\"></i> <span ng-if=\"$ctrl.address.city\">{{$ctrl.address.city}},</span> <span ng-if=\"$ctrl.address.state\">{{$ctrl.address.state}},</span> <span>{{$ctrl.address.country}}</span>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><aims-top-navbar enable-menu=\"true\" app-title=\"AIMS\" app-name=\"aims\" resources=\"landing\" notifications=\"index.notifications\" landing=\"landing\" support=\"index.support\"></aims-top-navbar><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/emptyList.tpl.html","<div class=\"text-center m-t-md m-b-lg\"><i class=\"fa {{$ctrl.icon}} fa-5x text-ultramuted m-b-sm\" aria-hidden=\"true\"></i><br><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">{{\'footer.name\' | i18next}}</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\" aria-hidden=\"true\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\" aria-hidden=\"true\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"aims-side-menu\"><li ui-sref-active=\"active\" class=\"m-t-md\"><a ui-sref=\"index.dashboard\"><i class=\"fa fa-tachometer fa-lg fa-fw\" aria-hidden=\"true\"></i> <span class=\"nav-label\">{{\'dashboard.nav\' | i18next}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.profile\"><i class=\"fa fa-user-circle-o fa-lg fa-fw\" aria-hidden=\"true\"></i> <span class=\"nav-label\">Profile</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.notifications\"><i class=\"fa fa-bell fa-lg fa-fw\" aria-hidden=\"true\"></i> <span class=\"nav-label\">Notifications</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.resources\"><i class=\"fa fa-cubes fa-lg fa-fw\" aria-hidden=\"true\"></i> <span class=\"nav-label\">{{\'resources.nav\' | i18next}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"app.adminAccess\"><a ui-sref=\"admin.access\"><i class=\"fa fa-lock fa-lg fa-fw\" aria-hidden=\"true\"></i> <span class=\"nav-label\">{{\'access.nav\' | i18next}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"app.notifierAccess\"><a ui-sref=\"admin.notifier\"><i class=\"fa fa-bullhorn fa-lg fa-fw\" aria-hidden=\"true\"></i> <span class=\"nav-label\">{{\'notifier.nav\' | i18next}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.support\"><i class=\"fa fa-life-ring fa-lg fa-fw\" aria-hidden=\"true\"></i> <span class=\"nav-label\">Support</span></a></li></ul></div></nav>");
$templateCache.put("app/components/common/spinner_double_bounce.tpl.html","<div class=\"m-lg text-center\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><h2 ng-if=\"$ctrl.size === \'lg\'\"><ng-transclude></ng-transclude></h2><h3 ng-if=\"$ctrl.size === \'md\'\"><ng-transclude></ng-transclude></h3><span ng-if=\"$ctrl.size === \'sm\'\"><ng-transclude></ng-transclude></span></div>");}]);